export default "__VITE_ASSET__B71icr2s__"